import { TICKER_SERIES_RESOURCE, TICKERS_RESOURCE } from '../api/resources';
import { getTickersForPositionUpdate } from '../selectors';
import { addResource, deleteResource, fetchResource, updateResource } from './remote';

export const fetchTickerSeries = fetchResource(TICKER_SERIES_RESOURCE);

export const updateTickerSeries = updateResource(TICKER_SERIES_RESOURCE);

export const addTickerSeries = addResource(TICKER_SERIES_RESOURCE);

export const cloneTickerSeries = addResource(TICKER_SERIES_RESOURCE, 'clone');

export const deleteTickerSeries = deleteResource(TICKER_SERIES_RESOURCE);

/**
 * Unlike most other operations updating ticker positions requires a separate call to update
 * positions of each ticker in the list.
 *
 * @param tickers
 */
export const updateTickerPositions = (tickers) => (dispatch) => {
  getTickersForPositionUpdate(tickers).forEach((ticker) =>
    dispatch(updateTicker(ticker.id, ticker)),
  );
};

export const updateTicker = updateResource(TICKERS_RESOURCE);

export const addTicker = addResource(TICKERS_RESOURCE);

export const deleteTicker = deleteResource(TICKERS_RESOURCE);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/ticker.js